document.addEventListener('DOMContentLoaded', function () {

  const trigger = document.querySelector('.products-trigger');
  const megaMenu = document.querySelector('.products-mega-menu');

  if(trigger && megaMenu){
    // 1. Trigger click par menu toggle ho aur event aage na jaye
    trigger.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      megaMenu.classList.toggle('active');
    });

    // 2. Menu ke andar click karne par menu band na ho
    megaMenu.addEventListener('click', function(e){
      e.stopPropagation();
    });

    // 3. Menu ke bahar page par kahin bhi click hone par dropdown close ho jaye
    document.addEventListener('click', function(){
      megaMenu.classList.remove('active');
    });
  }

  // Aapka purana tabs/panels wala code (jaise ka taisa rakha hai)
  const tabs = document.querySelectorAll('.mega-sidebar-item');
  const panels = document.querySelectorAll('.mega-panel');

  tabs.forEach(tab => {
    tab.addEventListener('click', function(){
      const target = this.dataset.target;

      tabs.forEach(t => t.classList.remove('active'));
      panels.forEach(p => p.classList.remove('active'));

      this.classList.add('active');

      const panel = document.querySelector(
        '.mega-panel[data-panel="' + target + '"]'
      );

      if(panel){
        panel.classList.add('active');
      }
    });
  });

});